import Image from 'next/image';
import { motion, type HTMLMotionProps } from 'framer-motion';

import { cn } from '#/lib/utils';

import image from './images/ellipse-purple.png';

export function EllipsePurple({ className, ...props }: HTMLMotionProps<'div'>) {
  return (
    <motion.div {...props} className={cn(className)}>
      <Image
        {...image}
        alt="Ellipse Purple"
        className="w-full h-full object-cover"
      />
    </motion.div>
  );
}
